import { FC } from 'react';
import { isFilled } from '@prismicio/client';
import type { KeyTextField } from '@prismicio/client';

interface EyebrowProps {
  text?: KeyTextField;
}

/**
 * Shared hero eyebrow: Manrope 700 / 20px / 140% / white, uppercase, no
 * tracking. Renders nothing when the field is empty.
 */
const Eyebrow: FC<EyebrowProps> = ({ text }) => {
  if (!isFilled.keyText(text)) {
    return null;
  }
  return (
    <span className="font-manrope text-[20px] font-bold uppercase leading-[1.4] tracking-normal text-white">
      {text}
    </span>
  );
};

export default Eyebrow;
